// GroupingPage.js
import React, { useState } from "react";
import {
  Box,
  Grid,
  Paper,
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";

// 地域と都道府県の定義
const regions = [
  {
    region: "北海道・東北",
    prefectures: [
      "北海道",
      "青森県",
      "岩手県",
      "宮城県",
      "秋田県",
      "山形県",
      "福島県",
    ],
  },
  {
    region: "関東",
    prefectures: [
      "茨城県",
      "栃木県",
      "群馬県",
      "埼玉県",
      "千葉県",
      "東京都",
      "神奈川県",
    ],
  },
  {
    region: "中部",
    prefectures: [
      "新潟県",
      "富山県",
      "石川県",
      "福井県",
      "山梨県",
      "長野県",
      "岐阜県",
      "静岡県",
      "愛知県",
    ],
  },
  {
    region: "近畿",
    prefectures: [
      "三重県",
      "滋賀県",
      "京都府",
      "大阪府",
      "兵庫県",
      "奈良県",
      "和歌山県",
    ],
  },
  {
    region: "中国",
    prefectures: ["鳥取県", "島根県", "岡山県", "広島県", "山口県"],
  },
  {
    region: "四国",
    prefectures: ["徳島県", "香川県", "愛媛県", "高知県"],
  },
  {
    region: "九州・沖縄",
    prefectures: [
      "福岡県",
      "佐賀県",
      "長崎県",
      "熊本県",
      "大分県",
      "宮崎県",
      "鹿児島県",
      "沖縄県",
    ],
  },
  {
    region: "地域その他",
    prefectures: ["海外（アメリカ）", "海外（その他）", "不明"],
  },
];

// 仮のユーザーデータ
const mockUsers = [
  { id: 1, name: "山田 太郎", prefecture: "東京都" },
  { id: 2, name: "佐藤 花子", prefecture: "神奈川県" },
  { id: 3, name: "鈴木 一郎", prefecture: "大阪府" },
  { id: 4, name: "ジョン・スミス", prefecture: "海外（アメリカ）" },
];

const GroupingPage = () => {
  const [selectedPref, setSelectedPref] = useState("");

  // 選択した都道府県でユーザーを絞り込み
  const filteredUsers = selectedPref
    ? mockUsers.filter((u) => u.prefecture === selectedPref)
    : mockUsers;

  return (
    <Box sx={{ flexGrow: 1, p: 3 }}>
      <Grid container spacing={2}>
        {/* 左エリア */}
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 3 }}>
            {/* 都道府県セレクトボックス */}
            <FormControl fullWidth variant="outlined" sx={{ mb: 3 }}>
              <InputLabel>都道府県を選択</InputLabel>
              <Select
                label="都道府県を選択"
                value={selectedPref}
                onChange={(e) => setSelectedPref(e.target.value)}
              >
                <MenuItem value="">
                  <em>すべて表示</em>
                </MenuItem>
                {regions.map((region) => (
                  <React.Fragment key={region.region}>
                    <MenuItem disabled>
                      <Typography variant="caption" color="text.secondary">
                        {region.region}
                      </Typography>
                    </MenuItem>
                    {region.prefectures.map((pref) => (
                      <MenuItem key={pref} value={pref}>
                        {pref}
                      </MenuItem>
                    ))}
                  </React.Fragment>
                ))}
              </Select>
            </FormControl>

            {/* ユーザー一覧 */}
            <Typography variant="h6" gutterBottom>
              ユーザー一覧
            </Typography>
            <List>
              {filteredUsers.map((user) => (
                <ListItem key={user.id} divider>
                  <ListItemText
                    primary={user.name}
                    secondary={user.prefecture}
                  />
                </ListItem>
              ))}
              {filteredUsers.length === 0 && (
                <ListItem>
                  <ListItemText primary="該当ユーザーがいません" />
                </ListItem>
              )}
            </List>
          </Paper>
        </Grid>

        {/* 右エリア（現状空） */}
        <Grid item xs={12} md={6}>
          {/* ここに後で右側UIを追加 */}
        </Grid>
      </Grid>
    </Box>
  );
};

export default GroupingPage;
